import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------
// Tema "Lovačka": krem podloga, smeđa kao glavna boja, maslinasto zelena kao akcent,
// tamno crvena za kritične vrijednosti (saldo ispod nule, istekla pretplata, prazna baterija).
// Struktura i nazivi ključeva su isti kao u originalnom Minimal templateu,
// pa sve komponente (Label, tabele, dugmad, sidebar) automatski preuzimaju nove boje.

// Topli sivo-smeđi neutralni tonovi (umjesto hladne sive)
const GREY = {
  0: '#FFFFFF',
  100: '#FBF8F2',
  200: '#F5F0E6',
  300: '#E6DDCD',
  400: '#CFC2AC',
  500: '#A89A83',
  600: '#7A6C58',
  700: '#574B3C',
  800: '#2F2A22',
  900: '#1E1A15',
};

// Glavna boja: smeđa (dugmad, linkovi, aktivna stavka u meniju)
const PRIMARY = {
  lighter: '#EFE3D3',
  light: '#A67C57',
  main: '#6B4A2E',
  dark: '#4E3520',
  darker: '#2E1F12',
  contrastText: '#FFFFFF',
};

// Akcent: maslinasto zelena
const SECONDARY = {
  lighter: '#E6EAD8',
  light: '#8A9A63',
  main: '#5B6B3A',
  dark: '#414D28',
  darker: '#262E17',
  contrastText: '#FFFFFF',
};

// Informativno: pijesak / svijetla smeđa
const INFO = {
  lighter: '#EDE6D8',
  light: '#BFA985',
  main: '#9C8360',
  dark: '#6F5C41',
  darker: '#3F3423',
  contrastText: '#FFFFFF',
};

// Uspjeh / online: zelena, malo svježija od akcenta
const SUCCESS = {
  lighter: '#DDE3CC',
  light: '#93A56A',
  main: '#5E7A3A',
  dark: '#3B4724',
  darker: '#232B14',
  contrastText: '#FFFFFF',
};

// Upozorenje: oker
const WARNING = {
  lighter: '#F6E7C8',
  light: '#E0B96A',
  main: '#C28A2C',
  dark: '#8C5F18',
  darker: '#58390A',
  contrastText: '#2F2A22',
};

// Kritično: tamno crvena
const ERROR = {
  lighter: '#F3DCD9',
  light: '#D06A63',
  main: '#9E2A2B',
  dark: '#7A1E1F',
  darker: '#4F1213',
  contrastText: '#FFFFFF',
};

const palette = {
  common: { black: '#000', white: '#fff' },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  divider: alpha(GREY[500], 0.24),
  text: {
    primary: GREY[800],
    secondary: GREY[600],
    disabled: GREY[500],
  },
  background: {
    paper: '#FFFBF3', // kartice i tabele
    default: '#F5F0E6', // podloga stranice
    neutral: '#E3D6BF', // zaglavlja tabela, sidebar kartica korisnika
  },
  action: {
    active: GREY[600],
    hover: alpha(PRIMARY.main, 0.06),
    selected: alpha(PRIMARY.main, 0.12),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(PRIMARY.main, 0.24),
    hoverOpacity: 0.06,
    disabledOpacity: 0.48,
  },
};

export default palette;